import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { LG, XL, XXL } from '@zendeskgarden/react-typography';
import { Button } from 'theme/Button';
import { trackClick } from 'utility/analytics';
import history from 'historyContainer';

import { GetStartedSection } from './components/GetStarted.styles';

const GetStarted = (props) => {
  function goToRequest() {
    trackClick(
      'submitARequest',
      'Submit RFQ',
      props.view || 'GetStartedFooter'
    );
    history.push('/buyers/m/rfq/overview');
  }

  function goToContact() {
    trackClick('contactUs', 'Contact Us', props.view || 'GetStartedFooter');
    history.push('/contact');
  }

  function goToApplication() {
    trackClick('submitSellersApplication', 'Submit Supply', 'CompanyOurModel');
    history.push('/why-pipesearch/m/supply/sellers-application');
  }

  return (
    <GetStartedSection>
      <Row justifyContent="between">
        <Col size="12" sm="auto">
          <XXL style={{ fontSize: '40px' }} bold navy tag="h2">
            Get in touch.
          </XXL>
          <XL light paddingTopMd slate tag="p">
            Whether you have project needs or supply you want to move, we can
            help.
          </XL>
        </Col>

        <Col size="12" sm="auto">
          <Row alignCenter style={{ marginTop: 20 }}>
            <Col alignCenter size={12} sm="auto">
              <Button onClick={goToRequest} pairButton size="large" primary>
                Pricing and Availability
              </Button>
            </Col>
            <Col size={12} sm="auto">
              <Button
                onClick={goToApplication}
                last
                pairButton
                size="large"
                secondary
              >
                Move Your Supply
              </Button>
            </Col>
            <Col size={12} sm="auto">
              <Button
                className="transparent"
                last
                pairButton
                size="large"
                primaryOutline
                onClick={goToContact}
              >
                Contact Us
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </GetStartedSection>
  );
};

export default GetStarted;
